"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = void 0;
const utils_1 = require("../utils");
const global_1 = require("./global");
const errors_1 = require("./errors");
const constants_1 = require("./constants");
const context_1 = require("./context");
class Logger {
    constructor(processor) {
        this.processor = processor;
    }
    static create(options) {
        const processorProvider = (0, global_1.getGlobal)(constants_1.GLOBAL_PROCESSOR_PROVIDER_KEY);
        if (!processorProvider) {
            throw new errors_1.MissingGlobalRegisterError(constants_1.GLOBAL_PROCESSOR_PROVIDER_KEY);
        }
        const resolvedOptions = (0, utils_1.resolveOptions)(options);
        const processor = processorProvider.create(resolvedOptions);
        return new Logger(processor);
    }
    /**
     * Get the default logger instance.
     * Use default options and resolve them from the environment.
     */
    static get default() {
        let globalLogger = (0, global_1.getGlobal)('logger');
        if (!globalLogger) {
            globalLogger = Logger.create();
            (0, global_1.registerGlobal)('logger', globalLogger);
        }
        return globalLogger;
    }
    child(context) {
        return new Logger(this.processor.child(context || {}));
    }
    with(context, fn) {
        return (0, context_1.withLogContext)(context, fn);
    }
    trace(context, msg, ...interpolationValues) {
        this.internalLog('trace', context, msg, interpolationValues);
    }
    debug(context, msg, ...interpolationValues) {
        this.internalLog('debug', context, msg, interpolationValues);
    }
    info(context, msg, ...interpolationValues) {
        this.internalLog('info', context, msg, interpolationValues);
    }
    warn(context, msg, ...interpolationValues) {
        this.internalLog('warn', context, msg, interpolationValues);
    }
    error(context, msg, ...interpolationValues) {
        this.internalLog('error', context, msg, interpolationValues);
    }
    fatal(context, msg, ...interpolationValues) {
        this.internalLog('fatal', context, msg, interpolationValues);
    }
    internalLog(level, context, msg, interpolationValues) {
        this.processor.write({
            level,
            context,
            message: msg,
            interpolationValues,
        });
    }
}
exports.Logger = Logger;
//# sourceMappingURL=logger.js.map